
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import Helpers from "../../../helpers/helperFunctions";
import PropTypes from "prop-types";
import { toggleActiveClassRegion } from "../../../actions/ui";
//import Config from "../../../config/main";
import { browserHistory, withRouter } from "react-router";
import { getAllRegionsFromSportsList } from "../../../helpers/regionListHelpers";
import Config from "../../../config/main";

class Region extends Component {
    constructor (props) {
        super(props);
        this.setRegionCompetitionIds = this.setRegionCompetitionIds.bind(this);
    }
    // Set active Region when user clicks to a game from Homepage , AfterSlashChar is Region Id
    componentDidMount () {
        let afterSlashChar = this.props.pathName.split('/')[3];
        afterSlashChar !== "all" && this.props.toggleActiveClassRegion(parseInt(afterSlashChar));

    }
    // Set Region Active class if User clicks directly to a Competition
    setRegionCompetitionIds (regionId, competitionId) {
        let { gameType, sportAlias, data: { regionAlias } } = this.props;
        const regionIdToSet = regionId === +this.props.params.regionId && (competitionId === +this.props.params.competitionId  || !competitionId)
            ? 'all'
            : regionId
        const competitionIdToSet = competitionId === +this.props.params.competitionId
            ? 'all'
            : competitionId
        browserHistory.push(`/${gameType}/${sportAlias}/${sportAlias === "all" ? regionAlias : regionIdToSet}/${competitionIdToSet || "all"}`);
        return this.props.toggleActiveClassRegion(regionIdToSet);
    }
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

Region.propTypes = {
    regionId: PropTypes.any,
    selectorKey: PropTypes.string,
    data: PropTypes.object,
    sportAlias: PropTypes.string,
    gameType: PropTypes.string,
    selectedRegionAndCompetition: PropTypes.func,
    competitionId: PropTypes.any,
    toggleActiveClassRegion: PropTypes.func,
    pathName: PropTypes.string
};

const mapStateToProps = (state, ownParams) => {
    return createSelector(
        [
            state => state.swarmData.data[ownParams.selectorKey] && JSON.stringify((() => {
                const allRegions = getAllRegionsFromSportsList(state.swarmData.data[ownParams.selectorKey])
                const region = allRegions.find(region => region.id === ownParams.regionId)

                let data = {};
                data.gamesCount = 0;
                data.regionAlias = region.alias;
                data.regionName = region.name;
                data.regionId = region.id;
                const sortedComp = Helpers.objectToArray(region.competition).sort((a, b) => a.order - b.order);
                data.competitionIds = (Config.removeOutright ? sortedComp.filter(item => !item.name.includes("Outright")) : sortedComp).map((comp) => {
                    data.gamesCount += comp.game;
                    return comp.id;
                });
                return data;
            })()),
            state => state.uiState.toggleRegionid.cursor,
            state => state.routing.locationBeforeTransitions.pathname,
            state => state.uiState.sportGamesCount
        ],
        (data, cursor, pathName, sportGamesCount) => {
            return {
                data: data && JSON.parse(data),
                cursor,
                pathName,
                sportGamesCount
            };
        });
};
const mapDispachToProps = (dispatch) => {
    return {
        toggleActiveClassRegion: (regionId) => dispatch(toggleActiveClassRegion(regionId))
    };
};
export default connect(mapStateToProps, mapDispachToProps)(withRouter(Region));